import { learningApi } from 'helpers';

const assignCourseToWorker = (data: any, languageCode: string = 'en') => {
  learningApi.defaults.headers['Accept-Language'] = languageCode;
  return learningApi.post(`/workers/learnerworkerbulk`, data);
};

const getWorkerCourses = (
  workerId: string,
  params: {
    pageNumber: number;
    pageSize: number;
    courseStatus?: 1 | 3;
    sortBy?: 'coursename' | 'completiondate' | 'expirationdate';
    sortDirection?: 'ASC' | 'DESC';
  },
  languageCode: string = 'en',
) => {
  learningApi.defaults.headers['Accept-Language'] = languageCode;
  const queryParams = new URLSearchParams({
    page: params.pageNumber.toString(),
    pageSize: params.pageSize.toString(),
  });

  if (params.courseStatus !== undefined) {
    queryParams.append('CourseStatus', params.courseStatus.toString());
  }
  if (params.sortBy) {
    queryParams.append('sortBy', params.sortBy);
  }
  if (params.sortDirection) {
    queryParams.append('sortDirection', params.sortDirection);
  }

  return learningApi.get(`/northpass/workers/${workerId}/courses?includePaging=true&${queryParams.toString()}`);
};

export default { assignCourseToWorker, getWorkerCourses };
